export default __webpack_public_path__ + "static/media/PDFfileicon.bc641d05.svg";